import React from 'react';
import styled from '../../../libs/styled.es.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  line-height: 29px;
  height: 30px;
  border-radius: 999px;
  width: fit-content;
  text-align: center;
  background: #f6f6f6;
  vertical-align: middle;
  justify-content: center;
  text-decoration: none;
  outline: 0;
  white-space: nowrap;
  border: none;
  padding: 0 12px;
  cursor: pointer;
`;
const Chip = (_a) => {
  var _b = _a, {
    onClick,
    children
  } = _b, props = __objRest(_b, [
    "onClick",
    "children"
  ]);
  return /* @__PURE__ */ React.createElement(Wrapper, __spreadProps(__spreadValues({}, props), {
    onClick
  }), children);
};

export { Chip };
